import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function ForceResetRoute({ children }) {
  const { loading, isLoggedIn, mustChangePassword } = useAuth();

  if (loading) {
    return null;
  }

  if (!isLoggedIn) {
    return <Navigate to="/giris-yap" replace />;
  }

  if (mustChangePassword) {
    return <Navigate to="/force-reset" replace />;
  }

  return children;
}